//@flow
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { HTMLView } from 'components/atoms/htmlView';
import './styles.scss';

type Props = {
  containerClassName?: string,
  headingClassName?: string,
  subHeadingClassName?: string,
  descriptionClassName?: string,
  heading: string,
  subHeading: string,
  description: string,
  animationKey?: string,
};

const CarouselStatements = (props: Props) => {
  const {
    containerClassName,
    headingClassName,
    subHeadingClassName,
    descriptionClassName,
    heading,
    subHeading,
    description,
    animationKey = false,
  } = props;

  return (
    <TransitionGroup className={containerClassName}>
      <CSSTransition
        classNames={'carousel-statement-card'}
        key={animationKey ? heading : description}
        timeout={300}
      >
        <div>
          <h3 className={headingClassName}>{heading}</h3>
          <h1 className={subHeadingClassName}>{subHeading}</h1>
          <div className={'description'}>
            <HTMLView
              className={descriptionClassName}
              html={description}
              tagName={'p'}
            />
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default CarouselStatements;
